import './Document.css';
import { fetchAssetByID } from '../../services/clientService';
import { logEvent } from '../../services/loggingService';
import { useEffect, useState, useContext } from 'react';
import { EventDataTypeEnum, LogEventType } from '../../utils/data/enums';
import { ModalContext, ModalTypes } from '../../store/ModalContext';

const Document = ({
    caption,
    title,
    editMode,
    containerAssets,
    id,
    portalId,
    portalName,
    isViewLive = false,
}) => {
    const [url, setUrl] = useState('');
    const [assetName, setAssetName] = useState('');
    const [assetId, setAssetId] = useState(null);
    const { showModal } = useContext(ModalContext);

    const getFileIcon = url => {
        let extension = url.split('.').pop();
        extension = extension.toLowerCase();

        switch (extension) {
            case 'doc':
            case 'docx':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_77768_1823)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#1052A2"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#63A3F0"
                            />
                            <path
                                d="M17.53 51.13C17 51.13 16.53 51 16.12 50.73C15.71 50.46 15.38 50.07 15.15 49.57C14.92 49.06 14.8 48.46 14.8 47.75C14.8 47.04 14.92 46.44 15.15 45.93C15.39 45.43 15.72 45.04 16.13 44.78C16.54 44.51 17.02 44.38 17.54 44.38C17.95 44.38 18.27 44.45 18.52 44.58C18.77 44.71 18.96 44.87 19.1 45.05C19.24 45.23 19.35 45.39 19.42 45.52H19.5V42.28H20.77V51.01H19.53V49.99H19.42C19.34 50.13 19.23 50.29 19.09 50.47C18.95 50.65 18.75 50.81 18.5 50.94C18.25 51.07 17.93 51.14 17.53 51.14V51.13ZM17.81 50.04C18.18 50.04 18.49 49.94 18.74 49.75C19 49.55 19.19 49.28 19.32 48.94C19.45 48.59 19.52 48.19 19.52 47.73C19.52 47.27 19.45 46.88 19.32 46.54C19.19 46.2 19 45.93 18.74 45.74C18.49 45.55 18.17 45.45 17.8 45.45C17.43 45.45 17.1 45.55 16.84 45.75C16.58 45.95 16.39 46.22 16.26 46.56C16.13 46.9 16.07 47.29 16.07 47.72C16.07 48.15 16.14 48.55 16.27 48.9C16.4 49.25 16.59 49.53 16.85 49.73C17.11 49.93 17.43 50.03 17.8 50.03L17.81 50.04ZM25.35 51.13C24.74 51.13 24.2 50.99 23.74 50.71C23.28 50.43 22.93 50.04 22.67 49.53C22.42 49.02 22.29 48.43 22.29 47.76C22.29 47.09 22.42 46.49 22.67 45.98C22.92 45.47 23.28 45.08 23.74 44.8C24.2 44.52 24.73 44.38 25.35 44.38C25.97 44.38 26.5 44.52 26.96 44.8C27.42 45.08 27.77 45.48 28.03 45.98C28.28 46.49 28.41 47.08 28.41 47.76C28.41 48.44 28.28 49.03 28.03 49.53C27.78 50.04 27.42 50.43 26.96 50.71C26.5 50.99 25.97 51.13 25.35 51.13ZM25.35 50.06C25.75 50.06 26.08 49.95 26.34 49.74C26.6 49.53 26.79 49.25 26.92 48.9C27.05 48.55 27.11 48.17 27.11 47.75C27.11 47.33 27.05 46.95 26.92 46.6C26.8 46.25 26.6 45.97 26.34 45.75C26.08 45.54 25.75 45.43 25.35 45.43C24.95 45.43 24.62 45.54 24.35 45.75C24.09 45.96 23.89 46.25 23.77 46.6C23.65 46.95 23.58 47.33 23.58 47.75C23.58 48.17 23.64 48.56 23.77 48.9C23.9 49.25 24.09 49.53 24.35 49.74C24.61 49.95 24.95 50.06 25.35 50.06ZM32.58 51.13C31.95 51.13 31.4 50.99 30.94 50.7C30.49 50.41 30.14 50.01 29.89 49.5C29.65 48.99 29.52 48.41 29.52 47.75C29.52 47.09 29.64 46.5 29.9 45.99C30.15 45.48 30.5 45.08 30.96 44.79C31.41 44.5 31.95 44.36 32.57 44.36C33.07 44.36 33.51 44.45 33.9 44.64C34.29 44.82 34.6 45.08 34.84 45.41C35.08 45.74 35.22 46.12 35.27 46.56H34.03C33.96 46.25 33.81 45.99 33.56 45.77C33.32 45.55 32.99 45.44 32.59 45.44C32.23 45.44 31.92 45.53 31.66 45.72C31.4 45.9 31.19 46.17 31.04 46.51C30.89 46.85 30.82 47.25 30.82 47.72C30.82 48.19 30.89 48.61 31.04 48.96C31.18 49.31 31.39 49.57 31.65 49.77C31.92 49.96 32.23 50.06 32.59 50.06C32.83 50.06 33.05 50.02 33.25 49.93C33.45 49.84 33.62 49.71 33.75 49.54C33.89 49.37 33.98 49.17 34.04 48.93H35.28C35.23 49.35 35.1 49.73 34.87 50.06C34.64 50.39 34.33 50.65 33.95 50.84C33.57 51.03 33.12 51.13 32.6 51.13H32.58Z"
                                fill="#EDEDFF"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77768_1823">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            case 'pdf':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_77768_1814)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#C11010"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#FF8585"
                            />
                            <path
                                d="M28.01 42.28V45.52H27.93C27.85 45.38 27.75 45.22 27.61 45.05C27.47 44.87 27.28 44.71 27.03 44.58C26.78 44.44 26.45 44.37 26.05 44.37C25.52 44.37 25.05 44.51 24.64 44.77C24.22 45.04 23.9 45.42 23.66 45.93C23.42 46.43 23.3 47.04 23.3 47.74C23.3 48.44 23.42 49.06 23.65 49.56C23.89 50.07 24.21 50.45 24.62 50.73C25.04 51 25.51 51.13 26.04 51.13C26.44 51.13 26.76 51.06 27.01 50.93C27.26 50.8 27.46 50.64 27.6 50.46C27.74 50.28 27.85 50.12 27.93 49.98H28.04V51H29.28V42.28H28.01ZM27.83 48.94C27.7 49.29 27.51 49.56 27.25 49.75C27 49.95 26.69 50.04 26.32 50.04C25.95 50.04 25.62 49.94 25.37 49.74C25.11 49.54 24.92 49.26 24.79 48.91C24.66 48.56 24.59 48.17 24.59 47.73C24.59 47.29 24.65 46.91 24.78 46.57C24.91 46.22 25.11 45.95 25.36 45.75C25.62 45.55 25.94 45.45 26.32 45.45C26.7 45.45 27.01 45.55 27.26 45.74C27.51 45.93 27.7 46.2 27.83 46.54C27.96 46.88 28.03 47.28 28.03 47.73C28.03 48.18 27.96 48.59 27.83 48.94ZM21.8 45.93C21.57 45.42 21.24 45.04 20.83 44.77C20.41 44.51 19.94 44.37 19.41 44.37C19.01 44.37 18.68 44.44 18.43 44.58C18.19 44.71 17.99 44.87 17.85 45.05C17.71 45.22 17.61 45.38 17.53 45.52H17.43V44.46H16.18V53.46H17.46V49.98H17.53C17.61 50.12 17.72 50.28 17.86 50.46C18 50.64 18.2 50.8 18.45 50.93C18.7 51.06 19.03 51.13 19.43 51.13C19.95 51.13 20.42 51 20.84 50.73C21.25 50.45 21.57 50.07 21.81 49.56C22.04 49.06 22.16 48.45 22.16 47.74C22.16 47.03 22.04 46.43 21.8 45.93ZM20.67 48.91C20.54 49.26 20.35 49.54 20.09 49.74C19.84 49.94 19.52 50.04 19.14 50.04C18.76 50.04 18.46 49.95 18.21 49.75C17.96 49.56 17.77 49.29 17.63 48.94C17.5 48.59 17.43 48.19 17.43 47.73C17.43 47.27 17.5 46.88 17.63 46.54C17.76 46.2 17.95 45.93 18.2 45.74C18.46 45.55 18.77 45.45 19.14 45.45C19.51 45.45 19.84 45.55 20.1 45.75C20.36 45.95 20.55 46.22 20.68 46.57C20.81 46.91 20.87 47.3 20.87 47.73C20.87 48.16 20.81 48.56 20.67 48.91Z"
                                fill="white"
                            />
                            <path
                                d="M32.81 43.87V44.46H34.22V45.48H32.81V51H31.53V45.48H30.52V44.46H31.53V43.7C31.53 43.29 31.62 42.95 31.8 42.68C31.98 42.41 32.22 42.2 32.51 42.07C32.81 41.93 33.13 41.87 33.47 41.87C33.73 41.87 33.95 41.89 34.13 41.93C34.31 41.97 34.45 42.01 34.54 42.04L34.24 43.07C34.18 43.06 34.1 43.04 34.01 43.01C33.91 42.99 33.8 42.97 33.67 42.97C33.36 42.97 33.13 43.05 33 43.2C32.87 43.36 32.81 43.58 32.81 43.87Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77768_1814">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            case 'csv':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clip-path="url(#clip0_77767_1772)">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#054F32"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#6FC5A4"
                            />
                            <path
                                d="M35.18 44.46L32.81 51.01H31.45L29.07 44.46H30.44L32.1 49.5H32.17L33.82 44.46H35.19H35.18ZM28.05 46.05L26.9 46.25C26.85 46.1 26.78 45.96 26.67 45.83C26.57 45.7 26.43 45.59 26.25 45.5C26.07 45.41 25.85 45.37 25.59 45.37C25.23 45.37 24.93 45.45 24.69 45.61C24.45 45.77 24.33 45.98 24.33 46.23C24.33 46.45 24.41 46.62 24.57 46.76C24.73 46.89 24.99 47 25.35 47.09L26.39 47.33C26.99 47.47 27.44 47.68 27.74 47.97C28.04 48.26 28.18 48.64 28.18 49.1C28.18 49.49 28.07 49.84 27.84 50.15C27.62 50.45 27.3 50.69 26.9 50.87C26.5 51.04 26.03 51.13 25.51 51.13C24.78 51.13 24.18 50.97 23.72 50.66C23.26 50.34 22.97 49.9 22.87 49.32L24.1 49.13C24.18 49.45 24.33 49.69 24.57 49.86C24.81 50.02 25.12 50.1 25.5 50.1C25.92 50.1 26.25 50.01 26.5 49.84C26.75 49.66 26.88 49.45 26.88 49.2C26.88 49 26.8 48.82 26.65 48.68C26.5 48.54 26.27 48.44 25.96 48.36L24.85 48.12C24.24 47.98 23.79 47.76 23.49 47.46C23.2 47.16 23.06 46.77 23.06 46.31C23.06 45.92 23.17 45.59 23.38 45.3C23.6 45.01 23.89 44.78 24.27 44.62C24.65 44.46 25.09 44.37 25.58 44.37C26.29 44.37 26.84 44.52 27.25 44.83C27.66 45.13 27.92 45.54 28.06 46.05H28.05ZM19.09 51.13C18.46 51.13 17.91 50.99 17.45 50.7C17 50.41 16.65 50.01 16.4 49.5C16.16 48.99 16.03 48.41 16.03 47.75C16.03 47.09 16.15 46.5 16.41 45.99C16.66 45.48 17.01 45.08 17.47 44.79C17.92 44.5 18.46 44.36 19.08 44.36C19.58 44.36 20.02 44.45 20.41 44.64C20.8 44.82 21.11 45.08 21.35 45.41C21.59 45.74 21.74 46.12 21.78 46.56H20.54C20.47 46.25 20.32 45.99 20.07 45.77C19.83 45.55 19.5 45.44 19.1 45.44C18.74 45.44 18.43 45.53 18.17 45.72C17.91 45.9 17.7 46.17 17.55 46.51C17.4 46.85 17.33 47.25 17.33 47.72C17.33 48.19 17.4 48.61 17.55 48.96C17.69 49.31 17.9 49.57 18.16 49.77C18.43 49.96 18.74 50.06 19.1 50.06C19.34 50.06 19.56 50.02 19.76 49.93C19.96 49.84 20.12 49.71 20.26 49.54C20.4 49.37 20.49 49.17 20.55 48.93H21.79C21.74 49.35 21.61 49.73 21.38 50.06C21.15 50.39 20.84 50.65 20.46 50.84C20.08 51.03 19.63 51.13 19.11 51.13H19.09Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77767_1772">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            case 'ppt':
            case 'pptx':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_77768_1827)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#F12D0F"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#FF8585"
                            />
                            <path
                                d="M29.24 45.93C29.01 45.42 28.68 45.04 28.27 44.77C27.85 44.51 27.38 44.37 26.85 44.37C26.45 44.37 26.12 44.44 25.87 44.58C25.63 44.71 25.43 44.87 25.29 45.05C25.16 45.22 25.05 45.38 24.98 45.52H24.87V44.46H23.62V53.46H24.9V49.98H24.98C25.05 50.12 25.16 50.28 25.3 50.46C25.45 50.64 25.64 50.8 25.89 50.93C26.14 51.06 26.47 51.13 26.87 51.13C27.4 51.13 27.87 51 28.28 50.73C28.69 50.45 29.01 50.07 29.25 49.56C29.48 49.06 29.6 48.45 29.6 47.74C29.6 47.03 29.48 46.43 29.24 45.93ZM28.12 48.91C27.98 49.26 27.79 49.54 27.54 49.74C27.28 49.94 26.96 50.04 26.58 50.04C26.22 50.04 25.91 49.95 25.65 49.75C25.4 49.56 25.21 49.29 25.07 48.94C24.94 48.59 24.87 48.19 24.87 47.73C24.87 47.27 24.94 46.88 25.07 46.54C25.2 46.2 25.39 45.93 25.64 45.74C25.9 45.55 26.21 45.45 26.58 45.45C26.97 45.45 27.28 45.55 27.54 45.75C27.8 45.95 27.99 46.22 28.12 46.57C28.25 46.91 28.32 47.3 28.32 47.73C28.32 48.16 28.25 48.56 28.12 48.91ZM21.84 45.93C21.6 45.42 21.28 45.04 20.86 44.77C20.45 44.51 19.98 44.37 19.45 44.37C19.04 44.37 18.72 44.44 18.47 44.58C18.22 44.71 18.03 44.87 17.89 45.05C17.75 45.22 17.64 45.38 17.57 45.52H17.46V44.46H16.22V53.46H17.49V49.98H17.57C17.65 50.12 17.75 50.28 17.9 50.46C18.04 50.64 18.23 50.8 18.48 50.93C18.74 51.06 19.06 51.13 19.46 51.13C19.99 51.13 20.46 51 20.87 50.73C21.28 50.45 21.61 50.07 21.84 49.56C22.08 49.06 22.2 48.45 22.2 47.74C22.2 47.03 22.08 46.43 21.84 45.93ZM20.71 48.91C20.58 49.26 20.39 49.54 20.13 49.74C19.87 49.94 19.56 50.04 19.18 50.04C18.8 50.04 18.5 49.95 18.25 49.75C17.99 49.56 17.8 49.29 17.67 48.94C17.53 48.59 17.47 48.19 17.47 47.73C17.47 47.27 17.53 46.88 17.66 46.54C17.79 46.2 17.98 45.93 18.24 45.74C18.49 45.55 18.81 45.45 19.18 45.45C19.55 45.45 19.88 45.55 20.13 45.75C20.39 45.95 20.59 46.22 20.71 46.57C20.84 46.91 20.91 47.3 20.91 47.73C20.91 48.16 20.84 48.56 20.71 48.91Z"
                                fill="white"
                            />
                            <path
                                d="M34.21 50.95C34.13 50.98 34.03 51.01 33.89 51.04C33.75 51.07 33.58 51.09 33.38 51.09C33.04 51.09 32.73 51.03 32.44 50.91C32.15 50.78 31.92 50.59 31.74 50.33C31.56 50.07 31.47 49.74 31.47 49.35V45.48H30.51V44.46H31.47V42.89H32.74V44.46H34.09V45.48H32.74V49.08C32.74 49.33 32.78 49.51 32.85 49.64C32.93 49.76 33.02 49.85 33.14 49.89C33.26 49.93 33.39 49.95 33.53 49.95C33.63 49.95 33.72 49.95 33.8 49.93C33.87 49.92 33.93 49.91 33.97 49.9L34.21 50.95Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77768_1827">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            case 'txt':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_77768_1808)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#B8B7B7"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#D9D9D9"
                            />
                            <path
                                d="M25.81 47.73L27.85 44.46H26.46L25 47.01L23.56 44.46H22.16L24.17 47.73L22.13 51H23.53L25 48.56L26.48 51H27.87L25.81 47.73Z"
                                fill="white"
                            />
                            <path
                                d="M32.34 50.95C32.26 50.98 32.16 51.01 32.02 51.04C31.88 51.07 31.71 51.09 31.51 51.09C31.17 51.09 30.86 51.03 30.57 50.91C30.28 50.78 30.05 50.59 29.87 50.33C29.69 50.07 29.6 49.74 29.6 49.35V45.48H28.64V44.46H29.6V42.89H30.87V44.46H32.22V45.48H30.87V49.08C30.87 49.33 30.91 49.51 30.99 49.64C31.06 49.76 31.15 49.85 31.27 49.89C31.39 49.93 31.52 49.95 31.66 49.95C31.76 49.95 31.85 49.95 31.93 49.93C32 49.92 32.06 49.91 32.11 49.9L32.34 50.95Z"
                                fill="white"
                            />
                            <path
                                d="M21.26 50.95C21.19 50.98 21.08 51.01 20.95 51.04C20.81 51.07 20.64 51.09 20.43 51.09C20.1 51.09 19.79 51.03 19.5 50.91C19.21 50.78 18.97 50.59 18.79 50.33C18.62 50.07 18.53 49.74 18.53 49.35V45.48H17.57V44.46H18.53V42.89H19.8V44.46H21.14V45.48H19.8V49.08C19.8 49.33 19.84 49.51 19.91 49.64C19.98 49.76 20.08 49.85 20.2 49.89C20.32 49.93 20.44 49.95 20.58 49.95C20.69 49.95 20.78 49.95 20.85 49.93C20.93 49.92 20.99 49.91 21.03 49.9L21.26 50.95Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77768_1808">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            case 'xls':
            case 'xlsx':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="56"
                        viewBox="0 0 41 56"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_77768_1819)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4 0C1.79 0 0 1.79 0 4V52C0 54.21 1.79 56 4 56H36.52C38.73 56 40.52 54.21 40.52 52V12.53L27.69 0H4Z"
                                fill="#2C946D"
                            />
                            <path
                                d="M28.03 12.53C27.02 11.79 27.69 0 27.69 0L40.52 12.53C40.52 12.53 29.38 13.51 28.03 12.53Z"
                                fill="#4FE4AB"
                            />
                            <path
                                d="M19.35 44.46L20.79 47.01L22.25 44.46H23.64L21.6 47.73L23.66 51H22.27L20.8 48.55L19.33 51H17.93L19.97 47.73L17.96 44.46H19.36H19.35ZM29.86 46.05L28.71 46.25C28.66 46.1 28.59 45.96 28.48 45.83C28.38 45.7 28.24 45.59 28.06 45.5C27.88 45.41 27.66 45.37 27.4 45.37C27.04 45.37 26.74 45.45 26.5 45.61C26.26 45.77 26.14 45.98 26.14 46.23C26.14 46.45 26.22 46.62 26.38 46.76C26.54 46.89 26.8 47 27.16 47.09L28.2 47.33C28.8 47.47 29.25 47.68 29.55 47.97C29.85 48.26 29.99 48.64 29.99 49.1C29.99 49.49 29.88 49.84 29.65 50.15C29.43 50.45 29.11 50.69 28.71 50.87C28.31 51.04 27.84 51.13 27.32 51.13C26.59 51.13 25.99 50.97 25.53 50.66C25.07 50.34 24.78 49.9 24.68 49.32L25.91 49.13C25.99 49.45 26.14 49.69 26.38 49.86C26.62 50.02 26.93 50.1 27.31 50.1C27.73 50.1 28.06 50.01 28.31 49.84C28.56 49.66 28.69 49.45 28.69 49.2C28.69 49 28.61 48.82 28.46 48.68C28.31 48.54 28.08 48.44 27.77 48.36L26.66 48.12C26.05 47.98 25.6 47.76 25.3 47.46C25.01 47.16 24.87 46.77 24.87 46.31C24.87 45.92 24.98 45.59 25.19 45.3C25.41 45.01 25.7 44.78 26.08 44.62C26.46 44.46 26.9 44.37 27.39 44.37C28.1 44.37 28.65 44.52 29.06 44.83C29.47 45.13 29.73 45.54 29.87 46.05H29.86ZM32.66 42.27V51H31.39V42.27H32.66Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_77768_1819">
                                <rect width="40.52" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                );
            default:
                //TODO: Code for handling other file types
                break;
        }
    };

    const downloadFile = () => {
        const link = document.createElement('a');
        link.href = url;
        link.download = title;
        link.click();
        if (!isViewLive) {
            logEvent(
                LogEventType.UserDocumentDownloaded,
                `Downloaded document ${title}`,
                {
                    subjectDataTypeId: EventDataTypeEnum.Asset,
                    subjectId: assetId,
                    subjectName: assetName,
                    contextDataTypeId: EventDataTypeEnum.Portal,
                    contextId: portalId,
                    contextName: portalName || undefined,
                },
            );
        }
    };

    const fetchAssets = async () => {
        // let urls = [];

        for (const containerAsset of containerAssets) {
            const fetchedAsset = await fetchAssetByID(
                containerAsset.assetId,
                null,
            );
            setAssetId(fetchedAsset.id);
            setUrl(fetchedAsset.url);
            setAssetName(fetchedAsset.name);
        }

        // const firstUrl = urls[0];
        // const fileCategory = getFileCategory(firstUrl);
        // if (fileCategory === 'video') {
        //     // setVideoUrl(firstUrl);
        // } else if (fileCategory === 'image') {
        //     // setImages(urls);
        // }
    };

    useEffect(() => {
        // if (caption)
        //     return;
        fetchAssets();

        // Cleanup function if needed
        return () => {
            // Any cleanup logic here
        };
    }, [containerAssets]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                marginTop: 'auto',
                marginBottom: 'auto',
                height: '100%',
                alignItems: 'center',
                cursor: editMode ? 'auto' : 'pointer',
                justifyContent: 'space-between',
            }}
            onClick={() => {
                if (editMode) {
                } else {
                    showModal({
                        type: ModalTypes.ASSET_VIEW,
                        title: assetName,
                        text: url,
                        download: downloadFile,
                    });
                    if (!isViewLive) {
                        logEvent(
                            LogEventType.UserDocumentViewed,
                            `Document ${assetName} viewed`,
                            {
                                subjectDataTypeId: EventDataTypeEnum.Asset,
                                subjectId: assetId,
                                subjectName: assetName,
                                contextDataTypeId: EventDataTypeEnum.Portal,
                                contextId: portalId,
                                contextName: portalName || undefined,
                            },
                        );
                    }
                }
            }}
        >
            <div
                className="document-content"
                style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}
            >
                <div className="document-icon">{getFileIcon(url)}</div>
                <div className="document-text">
                    <p
                        style={{
                            textAlign: 'center',
                            color: '#2F2B43',
                            fontSize: '20px',
                            fontWeight: '600',
                        }}
                    >
                        {title}
                    </p>
                    {caption && (
                        <p
                            style={{
                                color: 'rgba(47, 43, 67, 0.60)',
                                fontSize: '16px',
                                fontWeight: '500',
                            }}
                        >
                            {caption}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Document;
